import React, { useCallback, useEffect } from 'react'
import Heading from 'LuxKit/Typography/Heading'
import BodyText from 'LuxKit/Typography/BodyText'
import TextButton from 'LuxKit/Button/TextButton'
import TextArea from 'components/Common/Form/Input/TextArea'
import SolidSparklesIcon from 'LuxKit/Icons/solid/SolidSparklesIcon'
import Group from 'components/utils/Group'
import VerticalSpacer from 'components/Common/Spacing/VerticalSpacer'
import * as Analytics from 'analytics/analytics'

interface Props {
  hotelCity: string
  freeText: string
  onFreeTextChange: (text: string) => void
  onGenerate: () => void
  isGeneratingTrip: boolean
  stepNumber: number
  totalSteps: number
}

function AITripFreeTextSelection({
  hotelCity,
  freeText,
  onFreeTextChange,
  onGenerate,
  isGeneratingTrip,
  stepNumber,
  totalSteps,
}: Props) {
  const handleFreeTextChange = useCallback((e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const newValue = e.target.value
    onFreeTextChange(newValue)
  }, [onFreeTextChange])

  useEffect(() => {
    Analytics.trackClientEvent({
      subject: 'final_note',
      action: 'view',
      category: 'trip_planner',
      type: 'nonInteraction',
    })
  }, [])

  return (
    <Group direction="vertical" gap={20} desktopGap={24}>
      <VerticalSpacer gap={8}>
        <BodyText variant="large" weight="bold">{stepNumber} of {totalSteps}</BodyText>
        <Heading variant="heading1">
          Final <i>note</i>
        </Heading>
        <BodyText variant="large">
          Anything else we should know about your {hotelCity} trip?
        </BodyText>
      </VerticalSpacer>

      <Group direction="vertical" gap={12} desktopGap={24}>
        <BodyText variant="large">
          <strong>Notes</strong> (optional)
        </BodyText>
        <TextArea
          value={freeText}
          onChange={handleFreeTextChange}
          placeholder="e.g. Need wheelchair access, Travelling with toddler, Bringing a service dog"
          rows={3}
        />
      </Group>
      <div>
        <TextButton
          kind="primary"
          size="large"
          startIcon={<SolidSparklesIcon />}
          onClick={onGenerate}
          disabled={isGeneratingTrip}
        >
          Create my itinerary
        </TextButton>
      </div>
    </Group>
  )
}

export default AITripFreeTextSelection
